export const signout = (setAuth, removeCookies) => {
  localStorage.clear();
  removeCookies("__t0ken_amar_management");
  const intialAuthState = {
    isAuthenticated: false,
    role: "",
  };
  setAuth(() => intialAuthState);
};
